export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "stream_worker.c1dffa9b.worker.js");
}
